import { Injectable } from '@angular/core';
import * as S3 from 'aws-sdk/clients/s3';
import { LocalSaveService }  from './local-save-service.service'

@Injectable({
  providedIn: 'root'
})
  
export class UploadServiceService {

  FOLDER = 'scriptsPGV/';
 
  constructor(public localSave: LocalSaveService) { }

  uploadfile(file) {
 
    const bucket = new S3(
      {
        accessKeyId: 'AKIAJ4WWRIGU424U7Q7Q',
        secretAccessKey: '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',
        region: 'us-east-1'
      }
    );
 
    const params = {
      Bucket: 'twillbit',
      Key: this.FOLDER + file.name,
      Body: file
    };

    return new Promise (resolve => {
      bucket.upload(params, function (err, data) {
        if (err) {
          resolve(false);
        }
        resolve(data);
      });
    });
  }
}
